var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgInfoCircle = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M9 15.938A6.937 6.937 0 1 0 9 2.063a6.937 6.937 0 0 0 0 13.875Z" }), _jsx("path", { fill: "currentColor", d: "M9.68 12.189V8.064H8.32v4.125zM9 6.913a.913.913 0 1 0 0-1.826.913.913 0 0 0 0 1.826" })] }))); };
export default SvgInfoCircle;
